<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header-small signup-page section-image">
            <parallax class="page-header-image" style="background-image: url('img/homepage/blogHero.jpg') ;">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Blogs</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section">
                    <!-- <h3 class="title text-center">You may also be interested in</h3> -->
                    <br/>

                <div class="row">
                    <div class="col-md-8">

                    <div class="row">
                        <div v-for='blog in queriedData' :key="blog.id" class="col-md-6">
                            <card type="blog" plain>
                                <img slot="image" class="img rounded img-raised" :src="blog.picture"/>
                                <h6 class="category text-info">{{blogs.tag}}</h6>
                                <h4 class="card-title">
                                  <router-link v-bind:to="{name: 'blog-detail', params: { item_id: blog.id }}">
                                      {{blog.title}} 
                                    </router-link>
                                </h4>
                                <p class="card-description">
                                  <!-- <div v-html="blog.content" /> -->
                                    {{blog.content}}
                                    <router-link v-bind:to="{name: 'blog-detail', params: { item_id: blog.id }}">
                                      Read More 
                                    </router-link>
                                </p>
                                <div class="author">
                                    <!-- <img v-lazy="'img/olivia.jpg'" alt="..." class="avatar img-raised"> -->
                                    <span>{{blog.date}}</span>
                                </div>
                            </card>
                        </div>
                    </div>
                    <!-- v-model="pagination.full"
                    :total="total" -->
                    <div class="pagination-container justify-content-center">
                        <n-pagination type="primary"
                                      prev-item-classes="arrow-margin-left"
                                      next-item-classes="arrow-margin-right"
                                      v-model="pagination.currentPage"
                                      :per-page="pagination.perPage"
                                      :total="total"
                                      >

                        </n-pagination>
                    </div>

                    </div>
                   <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Pagination } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import db from '../../components/Firebase/firebaseInit'
  import Sidebar from '@/pages/bet/sidebar';
  import firebase from 'firebase';


  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Sidebar,
      Card,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Pagination.name]: Pagination,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.blogs;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.blogs.length;
    },
  },
    data() {
      return {
        year: new Date().getFullYear(),
        blogs: [],
        searchedData: [],
        pagination: {
          full: 1
        },
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
      }
    },
    created(){
    db.collection('blogs').orderBy("time").get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'title': doc.data().title,
          'content': doc.data().content,
          'picture': doc.data().picture,
          'date': doc.data().date,
          'time': doc.data().time
        }
        this.blogs.push(data)
      })
    })

    },
  }
</script>
<style>
</style>
